export default "/_next/static/chunks/fonts/din-bold-webfont-f626d06dcc88cd31499319e6b4844243.ttf";